/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".devicetest[_ngcontent-%COMP%]   .devicedata[_ngcontent-%COMP%]{margin-top:100px;padding:10px;font-size:large}"];
export { styles as styles };
